import React, {useContext, useEffect} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {Elink, LastPageVisited} from "../CommonComponents/Routes";
import {Modal} from "react-bootstrap";
import {Animation} from "./Animation";
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

const SubmitInventory = () => {
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    let JobIsOpen = RecordController.IsCustomerEditEstAftrBook;
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;

    useEffect(()=>{ // submit inventory page
        if (RecordController.Click) {
            Animation("submit-inventory",RecordController.Click);
        }
        axios({
            method: 'post',
            url: LastPageVisited,
            params: {estimate_key: Elink, last_visited_page: 'SUBMIT_INVENTORY'}
        })
    },[])
    const BackToMyHome= ()=>{ //back to home page after click on "I forgot something"
        RecordController.SetClick('back'); // set Animate class
        AnimationPrevious ( "back-go",  "submit-inventory",  "SHOW_MOBILE_LINK_MY_ROOMS", PageView);// set page and new class
    }
    const submitInventory = () => { // show submit inventory data
        return (
            <>
                <Modal className="alert-modal" show={!JobIsOpen || RecordController.ML_Start.InventoryType } onHide={JobIsOpen || !RecordController.ML_Start.InventoryType } id ="keypadModal"
                       style={{borderRadius: "30px",marginTop: "18%"}}>
                    <Modal.Body style={{height:"250px",textAlign: "center"}}> <b style={{fontSize: "115%"}}>
                        <img id="start-img" src={process.env.PUBLIC_URL + "/Images/alert.png"} alt="image" style={{height:"25%"}}/><br/><br/>
                        {
                            RecordController.ML_Start.InventoryType && JobIsOpen ? "This link is not valid for percentage inventory" :
                                "This job is currently booked, please contact your moving company to make any edits."
                        }
                    </b></Modal.Body>
                </Modal>
                <div className="container ">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-12 col-md-8 col-lg-6 col-xl-6 ">
                            <div className="card-st text-center">
                                <div className="submit-logo-image" style={{height: "25vh",marginTop: "6%"}}>
                                    <img src={RecordController.ML_Start.CompanyLogo ? RecordController.ML_Start.CompanyLogo :
                                        process.env.PUBLIC_URL + "/Images/mobileLinkLogo.png"} alt="image"/>
                                </div>
                                <div className="text-st">
                                    <img src={process.env.PUBLIC_URL + "/Images/check.png"} className="check" alt="image"/>
                                    <h2 style={{fontSize: "245%", color: GetTextColor(CustomerInvReq.BackgroundColor)}}>Thank you<br/>for adding your<br/>inventory!</h2>
                                    <p className="text-white-p mb-5" style={{fontSize: "100%", color: GetTextColor(CustomerInvReq.BackgroundColor)}}>This will help us get the most accurate estimate possible for you.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="btn btn-st forget-button next-button" type="submit" onClick={()=>BackToMyHome()}
                    style={{background: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}
                    ><b>I FORGOT SOMETHING</b></button>
                </div>
            </>
        )
    }
    return (
        <>
            <section className="gradient-custom desktop-vw" style={{background: CustomerInvReq.BackgroundColor}}>
                <div className={"submit-inventory"} style={{width: "100vw",height: "100vh"}}>
                    {submitInventory()}
                </div>
            </section>
            <section className="mobile-section-last mobile-vw" style={{background: CustomerInvReq.BackgroundColor}}>
                <svg id="curve" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1416.99 174.01">
                    <path className="curve-path" d="M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z"
                          transform="translate(0-135.53)" style={{position:"relative"}} fill="#f2f5f8"/>
                    <path className="curve-path"
                          d="M77.8,230.3S283.66,353,880.94,275.58s937.93,190.57,920,10.34V309.54H0V280.8Z"
                          transform="translate(0-135.53)" style={{position:"relative"}} fill="white"/>
                </svg>
                <div className={"submit-inventory"} style={{width: "100vw",height: "90vh"}}>
                    {submitInventory()}
                </div>
            </section>
        </>
    )
}
export default SubmitInventory;